import ApiService from "../../utils/fetch";

const inventoryDetailUrl = `${process.env.REACT_APP_BASE_URL}inventory`;


export const fetchInventoryDetailsData = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/inventoryDetails/${itemNo}/${siteCode}`;
  const response = await ApiService.get(url);
  return response.data;
};

export const fetchInventoryOnHand = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/inventoryOnHand/${itemNo}/${siteCode}`;
  const response = await ApiService.get(url);
  return response.data;
};

export const fetchInventoryTotalStock = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/inventoryTotalStock/${itemNo}/${siteCode}`;
  const response = await ApiService.get(url);
  return response.data;
};

// export const fetchInventoryBatches = async (itemNo, siteCode) => {
//   const url = `${inventoryDetailUrl}inventory/${itemNo}/${siteCode}`;
//   const response = await ApiService.get(url);
//   return response.data;
// };

export const fetchInventoryTimeline = async (inventoryId, siteCode, mode = "HYBRID",
  timeframe = "Q4FY25", realTime = false) => {
  const url = `${inventoryDetailUrl}/${inventoryId}/${siteCode}/inventoryView`
  const params = { mode, timeframe, realTime }
  const response = await ApiService.get(url, { params })
  return response.status === 200 ? response.data : { error: response.statusText };
}

export const fetchInventoryAlternateLocation = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/${itemNo}/${siteCode}/alternateLocation`;
  const response = await ApiService.get(url);
  return response.data;
}

export const fetchInventoryAlternateItems = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/${itemNo}/${siteCode}/alternateItems`;
  const response = await ApiService.get(url);
  return response.data;
}

export const inventoryAlternateLocAndItemsCompare = async (itemNo, siteCode, label,
  mode = "HYBRID", timeframe = "Q4FY25", siteCodes, inventoryIds) => {
  const url = `${inventoryDetailUrl}/${itemNo}/${siteCode}/${label}/compare`;
  const params = new URLSearchParams();
  params.append("mode", mode);
  params.append("timeframe", timeframe);
  if (siteCodes.length > 0)
    params.append("compareWithSites", siteCodes.join(","));
  if (inventoryIds.length > 0)
    params.append("compareWithItems", inventoryIds.join(","));

  const finalUrl = `${url}?${params.toString()}`;
  const response = await ApiService.get(finalUrl);
  return response.data;
}

export const fetchWhereUsedTreeData = async (itemNo, siteCode) => {
  const url = `${inventoryDetailUrl}/${itemNo}/${siteCode}/whereUsed`;
  const response = await ApiService.get(url);
  return response.data;
}



